// extracted by mini-css-extract-plugin
export default {"commentList":"CommentList_commentList__us8xh"};